import uuid from 'uuid/v4';
import {
  split,
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from 'apollo-utilities';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import localForage from 'localforage';

import { persistCache, LocalForageWrapper } from 'apollo3-cache-persist';

// @ts-ignore
import firebase from 'firebase';
import MessageTypes from 'subscriptions-transport-ws/dist/message-types';

let instance: ApolloClient<any>;
let wsClient: SubscriptionClient;

const createClient = async () => {
  const cache = new InMemoryCache({
    // dataIdFromObject: (object: { id?: any; __typename?: any }) => {
    //   if (object.id) {
    //     // eslint-disable-next-line no-underscore-dangle
    //     return `${object.__typename}-${object.id}`;
    //   }
    //   // return `${object.__typename}-${uuid()}`;
    // },
  });

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  await persistCache({
    cache,
    maxSize: false,
    storage: new LocalForageWrapper(localForage),
    // @ts-ignore
    // storage: localForage as PersistentStorage<
    //   PersistedData<NormalizedCacheObject>
    // >,
  });

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  });

  wsClient = new SubscriptionClient(process.env.REACT_APP_GRAPHQL_WS_ENDPOINT, {
    lazy: true,
    reconnect: true,
    connectionParams: async () => {
      const token = await firebase.auth().currentUser?.getIdToken();

      return {
        Authorization: `Bearer ${token}`,
      };
    },
  });

  wsClient.onConnected(() => {
    console.debug('Web Socket connection established');
  });

  wsClient.onConnecting(() => {
    console.debug('Establishing Web Socket connection..');
  });

  wsClient.onDisconnected(() => {
    console.debug('Web Socket connection disconnected');
  });

  wsClient.onReconnecting(() => {
    console.debug('Reconnecting Web Socket connection');
  });

  wsClient.onReconnected(() => {
    console.debug('Web Socket reconnection established');
  });

  wsClient.onError(() => {
    console.debug('Error on Web Socket interface');
  });

  const wsLink = new WebSocketLink(wsClient);

  const authLink = setContext(async (_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = await firebase.auth().currentUser?.getIdToken();
    // return the headers to the context so httpLink can read them
    return {
      uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  const link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    authLink.concat(httpLink),
  );

  return new ApolloClient({
    link,
    cache,
  });
};

export const setupClient = async (): Promise<ApolloClient<any>> => {
  if (instance) return instance;
  instance = await createClient();
  return instance;
};

export const getClient = () => instance;

export const restartWebsockets = () => {
  // Copy current operations
  const operations = Object.assign({}, wsClient.operations);

  console.debug('Closing existing websocket connection');
  // Close connection
  wsClient.close(true);

  console.debug('Opening a new websocket connection');
  // Open a new one
  // @ts-ignore
  wsClient.connect();

  // Push all current operations to the new connection
  Object.keys(operations).forEach((id) => {
    // @ts-ignore
    wsClient.sendMessage(id, MessageTypes.GQL_START, operations[id].options);
  });
};
